import { Component, OnInit, Inject } from '@angular/core';
import { PageComponent, ModalService, ICC_PAGE_DATA } from '@icc/configurator/shared';
import { isObject } from '@icc/shared/helpers';
import { Reinforcement } from '@icc/window-door/types';
import { SharedFacade } from '@icc/configurator/shared';
import { PriceBaseService } from '@icc/price/b2b';
import { APP_CONFIG, AppConfigFactory } from '@icc/shared';
@Component({
    selector: 'icc-reinforcements-list-page',
    templateUrl: './reinforcements-list-page.component.html',
    styleUrls: ['./reinforcements-list-page.component.scss'],
    standalone: false
})
export class ReinforcementsListPageComponent extends PageComponent  implements OnInit {
  public title = 'WINDOW|Wybierz wzmocnienie';
  public options = [];
  public reinforcements: Reinforcement[] = [];
  public selectedReinforcement: Reinforcement | null = null;
  public currency: any;
  hiddenPrice = false;
  constructor(
    private sharedFacade: SharedFacade,
    private priceBaseService: PriceBaseService,
    @Inject(APP_CONFIG) public config: AppConfigFactory,
    @Inject(ICC_PAGE_DATA)
    private pageData: {
        reinforcements: Reinforcement[];
        selectedReinforcement: Reinforcement;
        currency: any;
    },
  ) {
    super();
  }

  ngOnInit() {
    this.hiddenPrice =
            (this.config().preset === 'b2c' && this.config().hidePricesInB2cConfigurator)
            || (this.config().IccConfig.Configurators.hideProfilePrice);
    this.reinforcements = this.pageData.reinforcements;
    this.selectedReinforcement = this.pageData.selectedReinforcement;
    this.currency = this.pageData.currency;
  }

  selectReinforcement(reinforcement: Reinforcement) {
    this.sharedFacade.closePage(reinforcement);
  }

  close() {
    this.sharedFacade.closePage({ colors: this.pageData.selectedReinforcement});
  }

  priceMarket(price: number) {
    return this.priceBaseService.addMarginMarketFactor(price);
  }

}
